import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { HTTP_CP_ListSignInCompanies_Response_Company } from '@api-new/authservice';
import { AuthFacadeService } from '@app/auth/auth-facade.service';
import { SignInCodeErrorComponent } from '@app/auth/components/sign-in-code-error/sign-in-code-error.component';
import { LoginCompanySelectItemComponent } from '@app/auth/pages/login-company-select/components/login-company-select-item/login-company-select-item.component';
import { ActivityLogClickDirective } from '@client-ui/directives/activity-log-click.directive';
import { paths } from '@platform/paths';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { ANALYTIC_CLICK_EVENT_NAMES } from '@shared/constants/analytic-click-event-names';
import { ButtonDirective } from 'primeng/button';
import { take } from 'rxjs/operators';

@Component({
  selector: 'cp-login-company-select',
  templateUrl: './login-company-select.component.html',
  styleUrls: ['../../auth-theme.scss', 'login-company-select.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    LoginCompanySelectItemComponent,
    RouterLink,
    IconComponent,
    ButtonDirective,
    AsyncPipe,
    ActivityLogClickDirective,
    SignInCodeErrorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginCompanySelectComponent implements OnInit {
  private readonly authFacade = inject(AuthFacadeService);

  protected readonly companies$ = this.authFacade.signInCompanies$;
  protected readonly authError$ = this.authFacade.authError$;
  protected readonly isIncorrectCodeError$ = this.authFacade.isIncorrectCodeError$;

  protected email: string;

  protected readonly paths = paths;
  protected readonly AnalyticClickEventNames = ANALYTIC_CLICK_EVENT_NAMES;

  ngOnInit(): void {
    this.authFacade.email$.pipe(take(1)).subscribe((email) => {
      if (!email) {
        this.authFacade.navigateToCheckMail();
      } else {
        this.email = email;
      }
    });
  }

  protected selectCompany(company: HTTP_CP_ListSignInCompanies_Response_Company): void {
    this.authFacade.selectCompany(company.id);
  }
}
